<template>
  <SurveyFrontEnd
    type="result"
    :title="title"
    :content="content"
    :btn-text="btnText"
    :image-src="imageSrc"
    btn-url="preview"
    :style="bgColor"
  />
</template>

<script>
import '@/assets/css/te-cutsom.min.css';
import { mapMutations, mapState } from 'vuex';
import comTools from '@/tools/com';
import SurveyFrontEnd from '@/components/SurveyFrontEnd.vue';
import SurveyService from '../service/SurveyService';

export default {
  name: 'Result',
  components: {
    SurveyFrontEnd
  },
  data() {
    return {
      title: undefined,
      content: undefined,
      btnText: undefined,
      imageSrc: undefined,
      btnUrl: undefined,
      SurveyTemplateData: {},
      formID: this.$route.query.formID,
      surveyFrontEndWording: {
        imageSrc: '',
        title: '',
        content: ''
      }
    };
  },
  created() {
    this.getForm();
  },
  computed: {
    ...mapState('form', ['surveyTemplateData']),
    ...mapState('formSetting', ['themeColor', 'bgColor'])
  },
  methods: {
    ...mapMutations('form', ['setFormData']),
    ...mapMutations('formSetting', ['set']),
    hexToRgbA(sHex, alpha = 1) {
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      let sColor = sHex.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#';
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        const sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt(sColor.slice(i, i + 2), 16));
        }
        return `${sColorChange.join(',')},${alpha}`;
      }
      return sColor;
    },
    getFormInfo(formInfo, id) {
      const haveTarget = formInfo.find((d) => d.formparam === id);
      if (haveTarget) {
        return haveTarget.formvalue;
      }
      return haveTarget;
    },
    getForm() {
      const params = {
        formID: this.formID
      };
      SurveyService.getSurvayTemplate(params).then((res) => {
        if (res.success) {
          // this.getLanguage();
          const { formInfo } = res.data[0]; // 2020.09.15 api回傳值修改為list Adam
          this.formImage = this.getFormInfo(formInfo, 'FormImage');

          this.surveyFrontEndWording.imageSrc = this.getFormInfo(
            formInfo,
            'AfterEnd_ImageSrc'
          );
          this.surveyFrontEndWording.title = this.getFormInfo(
            formInfo,
            'AfterEnd_Title'
          );
          this.surveyFrontEndWording.content = (
            this.getFormInfo(formInfo, 'AfterEnd_Content') || ''
          ).replace(/{tspFormEnd}/g, new Date(this.EndTime).toLocaleString());
          if (this.isOutTime) {
            if (this.isTooEarly) {
              this.surveyFrontEndWording.imageSrc = this.getFormInfo(
                formInfo,
                'BeforeStart_ImageSrc'
              );
              this.surveyFrontEndWording.title = this.getFormInfo(
                formInfo,
                'BeforeStart_Title'
              );
              this.surveyFrontEndWording.content = (
                this.getFormInfo(formInfo, 'BeforeStart_Content') || ''
              ).replace(
                /{tspFormStart}/g,
                new Date(this.StartTime).toLocaleString()
              );
            }
          }
          this.placeHolder = this.getFormInfo(formInfo, 'PlaceHolder');

          this.submitForm = this.getFormInfo(formInfo, 'submitButtonWording');

          this.showCountDown = res.data[0].formLifeCycle
            && res.data[0].formLifeCycle > 0
            && res.data[0].ration === true;

          this.callGetFormDone = true;
          // this.SurveyTemplateData = res.data;
          const tmpData = res.data[0];
          this.SurveyTemplateData = tmpData;
          // 塞Active值 做跳題
          this.SurveyTemplateData.formDetail.forEach((element) => {
            const data = element;
            data.Active = true;
            data.isMsutAlert = false;
          });
          this.setFormData({
            id: 'surveyTemplateData',
            value: this.SurveyTemplateData
          });
          this.set({
            id: 'bgColor',
            value: this.getFormInfo(formInfo, 'bgColor')
          });
          this.set({
            id: 'themeColor',
            value: {
              '--theme-color': this.hexToRgbA(
                this.getFormInfo(formInfo, 'themeColor')
              )
            }
          });
          this.set({
            id: 'themeFontColor',
            value: this.getFormInfo(formInfo, 'themeFontColor')
          });
          this.set({
            id: 'bgFontColor',
            value: this.getFormInfo(formInfo, 'bgFontColor')
          });
          this.AllQustionCnt = this.SurveyTemplateData.formDetail.length;
          // 塞Active值 做跳題
          if (this.surveyTemplateData) {
            this.title = comTools.getFormInfo(formInfo, 'EndPage_Title');
            const desc = comTools.getFormInfo(formInfo, 'EndPage_Desc');
            if (desc) {
              this.content = desc
                .replace(/\r\n/g, '<br />')
                .replace(/\r/g, '<br />')
                .replace(/\n/g, '<br />');
            }
            this.btnText = comTools.getFormInfo(formInfo, 'EndPage_ButtonName');
            this.imageSrc = comTools.getFormInfo(formInfo, 'EndPage_Image');
            this.btnUrl = comTools.getFormInfo(formInfo, 'EndPage_ButtonURL');
          } else {
            this.$router.push({ name: 'Invaild' });
          }
        } else {
          this.$router.replace({ name: 'Error' });
        }
      });
    }
  }
};
</script>
